/**
 * An acknowledged Prioritization Inversion, drawn on the ranked row it
 * qualifies (owner, 2026-10-30: the exception beside the thing it qualifies,
 * not only on the governance page where it was acknowledged).
 *
 * The rank is kept, by canon; the mark says the item is ranked above the item
 * it depends on, and gives the reason the person who published it wrote.
 */
import type { InversionAcknowledgment } from '../../../lib/prioritizationInversionDetector';

export function InversionMark({
  acknowledgment,
  lowerTitle,
  acknowledgedByName,
}: {
  acknowledgment: InversionAcknowledgment;
  /** The title of the item it depends on, when known. */
  lowerTitle: string | null;
  /** The name of the person who acknowledged it, when known; else the id stands. */
  acknowledgedByName: string | null;
}) {
  const a = acknowledgment;
  const when = a.acknowledgedAt instanceof Date && !Number.isNaN(a.acknowledgedAt.getTime())
    ? a.acknowledgedAt.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })
    : null;
  return (
    <p data-testid="inversion-mark" className="mt-1 text-xs leading-relaxed text-[var(--mustard)]">
      <span className="font-medium">Inversion acknowledged:</span> ranked #{a.higherRank} above “{lowerTitle ?? 'the item it depends on'}” (#{a.lowerRank}), which it depends on.
      {' '}Reason: “{a.rationale}”
      <span className="text-[var(--text-ter)]">
        {' '}· {acknowledgedByName ?? a.acknowledgedBy}
        {when ? ` · ${when}` : ''}
      </span>
    </p>
  );
}
